import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  Chip,
  CircularProgress,
} from "@mui/material";
import { Box } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import axios from "axios";
import Key from "../../../clientVariables.json";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { getCandidateDetailAction } from "../redux/action";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { myCandidatesSelector } from "../redux/selector";
import { userSelector } from "../../user-redux/selector";

const Skills = ({ formDataHnadler }) => {
  const dispatch = useDispatch();
  const { candidateDetails } = useSelector(myCandidatesSelector);
  const { user } = useSelector(userSelector);

  const [formData, setFormData] = useState({
    skills:
      candidateDetails?.skills !== ""
        ? candidateDetails?.skills?.split(",")
        : [],
    newSkill: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      skills:
        candidateDetails?.skills !== ""
          ? candidateDetails?.skills?.split(",")
          : [],
    });
  }, [candidateDetails]);

  useEffect(() => {
    formDataHnadler(
      {
        skills: formData.skills,
      },
      "f4"
    );
  }, []);

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleAddSkill = () => {
    if (formData.newSkill.trim() !== "") {
      if (formData.skills.length < 1500) {
        setFormData({
          ...formData,
          skills: [...formData.skills, formData.newSkill.trim()],
          newSkill: "",
        });
      } else {
        // setSnackbarOpen(true);
        handleOpenSnackbar("You can add up to 15 skills.", "error");
      }
    }
  };

  const handleRemoveSkill = (index) => {
    const updatedSkills = formData.skills.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      skills: updatedSkills,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    await formDataHnadler(
      {
        skills: formData.skills,
      },
      "f4"
    );

    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/other/${candidateDetails?.candidate_id}`,
        {
          skills: formData.skills.join(","),
        }
      );
      handleOpenSnackbar("skills updated", "success");
      getCandidateDetailAction(candidateDetails?.candidate_id, user?.id)
    } catch (error) {
      console.error(error);
      handleOpenSnackbar("Something went wrong", "error");
    }
    setIsSubmitting(false);
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        title={
          <Typography variant="h6" sx={headerStyles}>
            Update Skills
          </Typography>
        }
      />
      <CardContent
        sx={{
          ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Skills
                </Typography>
                <TextField
                  id="skills"
                  label=""
                  variant="outlined"
                  placeholder="Type a skill and press Enter"
                  value={formData.newSkill}
                  onChange={handleInputChange("newSkill")}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAddSkill();
                    }
                  }}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              {formData?.skills?.map((skill, index) => (
                <Chip
                  key={index}
                  label={skill}
                  onDelete={() => handleRemoveSkill(index)}
                  sx={{ margin: "4px" }}
                />
              ))}
            </Grid>

            {/* <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <InfoOutlined sx={{ fontSize: "16px", color: "rgb(102, 120, 156)" }} />
                <Typography paragraph sx={{ fontSize: "14px", color: "rgb(102, 120, 156)", margin: 0 }}>
                  You can add up to 15 skills
                </Typography>
              </Box>
            </Grid> */}

            <Grid item xs={12} textAlign="end">
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#406882" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
      {/* <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="You can add up to 15 skills."
      /> */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Card>
  );
};

export default Skills;

const cardStyles = {
  boxShadow: "none",
  borderRadius: "8px",
};

const headerStyles = {
  color: "rgb(102, 120, 156)",
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  color: "rgb(160, 171, 184)",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
